import { Device } from './types';

const mobileMargin = 3.5;
const tabletMargin = 2.2;
const desktopMargin = 1.5;

export default function getDimensions(device: Device ): any {
    let margin, height, width, fontSize, marginTop, top, bottom, left, right;
    switch (device.FormFactor) {
        case 'mobile' : {
            margin = mobileMargin;
            break;
        }
        case 'tablet' : {
            margin = tabletMargin;
            break;
        }
        case 'desktop' : {
            margin = desktopMargin;
            break;
        }
        default : {
            margin = tabletMargin;
        }
    }

    switch(device.position) {
        case 'vertical': {
            height = String(4*margin) + "vw";
            width = height;
            fontSize = String(2*margin) + "vw";
            marginTop = String(margin/2) + "vw";
            top = bottom = left = right = String(margin) + "vw";
        }
        case 'horizontal':
        default : {
            height = String(2*margin) + "vw";
            width = height;
            fontSize = String(margin) + "vw";
            marginTop = String(margin/4) + "vw";
            top = bottom = left = right = String(margin/2) + "vw";
        }
    }

    return ({
        toolbars: { height },
        title: {
            fontSize,
            marginTop
        },
        buttons: {
            buttonSize : {
                height,
                width
            },
            downloadButton: {
                fontSize,
                bottom,
                left
            },
            deleteButton: {
                fontSize,
                bottom,
                right
            },
            backButton: {
                fontSize,
                top,
                left
            },
            closeButton: {
                fontSize,
                top,
                right
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/components/fileeditor/getDimensions.tsx